import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import HomeIcon from '@mui/icons-material/Home';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Grid } from "@mui/material";

const theme = createTheme();

function MainNavigation() {
  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Toolbar sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <IconButton sx={{marginTop: '7px'}} size="large" color="inherit" aria-label="home" href="/">
            <HomeIcon />
          </IconButton>
          <Typography
            component="h2"
            variant="h5"
            color="inherit"
            align="center"
            noWrap
            sx={{ flex: 1 }}
          >
          </Typography>
          <Button sx={{marginTop: '7px'}} underline="none" component="button" color="inherit" href="/portfolio">Portfolio</Button>
        </Toolbar>
      </ThemeProvider>
    </Grid>
  );
}

export default MainNavigation;